var __values = (this && this.__values) || function (o) {
    var m = typeof Symbol === "function" && o[Symbol.iterator], i = 0;
    if (m) return m.call(o);
    return {
        next: function () {
            if (o && i >= o.length) o = void 0;
            return { value: o && o[i++], done: !o };
        }
    };
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __spread = (this && this.__spread) || function () {
    for (var ar = [], i = 0; i < arguments.length; i++) ar = ar.concat(__read(arguments[i]));
    return ar;
};
import * as classNames from 'classnames';
function mergeAttrs() {
    var attrDicts = [];
    for (var _i = 0; _i < arguments.length; _i++) {
        attrDicts[_i] = arguments[_i];
    }
    if (attrDicts.length === 0) {
        return {};
    }
    var eventHandlers = {};
    var classes = [];
    var merged = attrDicts[0];
    try {
        for (var _a = __values(Object.keys(merged)), _b = _a.next(); !_b.done; _b = _a.next()) {
            var k = _b.value;
            if (merged[k] === undefined) {
                delete merged[k];
            }
        }
    }
    catch (e_1_1) { e_1 = { error: e_1_1 }; }
    finally {
        try {
            if (_b && !_b.done && (_c = _a.return)) _c.call(_a);
        }
        finally { if (e_1) throw e_1.error; }
    }
    try {
        for (var attrDicts_1 = __values(attrDicts), attrDicts_1_1 = attrDicts_1.next(); !attrDicts_1_1.done; attrDicts_1_1 = attrDicts_1.next()) {
            var attrs = attrDicts_1_1.value;
            try {
                for (var _d = __values(Object.keys(attrs)), _e = _d.next(); !_e.done; _e = _d.next()) {
                    var attr = _e.value;
                    var value = attrs[attr];
                    if (value === undefined) {
                    }
                    else if (value === mergeAttrs.DELETE) {
                        delete merged[attr];
                    }
                    else if (value === mergeAttrs.UNDEFINED) {
                        merged[attr] = undefined;
                    }
                    else if (attr === 'style') {
                        merged[attr] = Object.assign({}, merged[attr], value);
                    }
                    else if (attr === 'className') {
                        classes.push(value);
                    }
                    else if (attr === 'ref' || /^on[A-Z]/.test(attr)) {
                        (eventHandlers[attr] || (eventHandlers[attr] = [])).push(value);
                    }
                    else {
                        merged[attr] = value;
                    }
                }
            }
            catch (e_2_1) { e_2 = { error: e_2_1 }; }
            finally {
                try {
                    if (_e && !_e.done && (_f = _d.return)) _f.call(_d);
                }
                finally { if (e_2) throw e_2.error; }
            }
        }
    }
    catch (e_3_1) { e_3 = { error: e_3_1 }; }
    finally {
        try {
            if (attrDicts_1_1 && !attrDicts_1_1.done && (_g = attrDicts_1.return)) _g.call(attrDicts_1);
        }
        finally { if (e_3) throw e_3.error; }
    }
    if (classes.length) {
        merged.className = classNames(classes);
    }
    var _loop_1 = function (attr) {
        var funcs = eventHandlers[attr];
        if (funcs.length === 1) {
            merged[attr] = funcs[0];
        }
        else {
            merged[attr] = function () {
                var args = [];
                for (var _i = 0; _i < arguments.length; _i++) {
                    args[_i] = arguments[_i];
                }
                var result = undefined;
                try {
                    for (var funcs_1 = __values(funcs), funcs_1_1 = funcs_1.next(); !funcs_1_1.done; funcs_1_1 = funcs_1.next()) {
                        var func = funcs_1_1.value;
                        var params = result === undefined ? args : __spread(args, [result]);
                        result = func.apply(void 0, __spread(params));
                    }
                }
                catch (e_4_1) { e_4 = { error: e_4_1 }; }
                finally {
                    try {
                        if (funcs_1_1 && !funcs_1_1.done && (_a = funcs_1.return)) _a.call(funcs_1);
                    }
                    finally { if (e_4) throw e_4.error; }
                }
                return result;
                var e_4, _a;
            };
        }
    };
    try {
        for (var _h = __values(Object.keys(eventHandlers)), _j = _h.next(); !_j.done; _j = _h.next()) {
            var attr = _j.value;
            _loop_1(attr);
        }
    }
    catch (e_5_1) { e_5 = { error: e_5_1 }; }
    finally {
        try {
            if (_j && !_j.done && (_k = _h.return)) _k.call(_h);
        }
        finally { if (e_5) throw e_5.error; }
    }
    return merged;
    var e_1, _c, e_3, _g, e_2, _f, e_5, _k;
}
(function (mergeAttrs) {
    mergeAttrs.DELETE = Symbol('delete');
    mergeAttrs.UNDEFINED = Symbol('undefined');
})(mergeAttrs || (mergeAttrs = {}));
export default mergeAttrs;
//# sourceMappingURL=index.js.map